import cn from './card.module.css';

const TransactionItemBlock = ({
  children,
}: {
  children: React.JSX.Element;
}) => <div className={cn.transactionItemBlock}>{children}</div>;

export default TransactionItemBlock;
